import { instance } from '@/shared/lib/clientAxios';
import { useInfiniteQuery } from '@tanstack/react-query';

type ResponseData = {
  usrKey: string; // 사용자 키
  buddySeqNo: number; // 친구 고유 번호
  buddyNm: string; // 친구 이름
  keyCommNo: string | null; // 주요 연락처
  number015: string | null; // 015 번호
  emailId: string; // 이메일 ID
  coNm: string | null; // 회사 이름
  coDept: string | null; // 회사 부서
  coHandle: string | null; // 회사 직위
  natCd: string | null; // 국가 코드
  coZipCd: string | null; // 회사 우편번호
  coAddr: string | null; // 회사 주소
  coNumber: string | null; // 회사 전화번호
  faxNumber: string | null; // 팩스 번호
  homeZipCd: string | null; // 집 우편번호
  homeAddr: string | null; // 집 주소
  homeNumber: string | null; // 집 전화번호
  homepageUrl: string | null; // 홈페이지 URL
  messenger: string | null; // 메신저 ID
  birthSolarFlag: string | null; // 양력/음력 구분
  birthday: string | null; // 생일
  marriageDay: string | null; // 결혼기념일
  genderFlag: string | null; // 성별 구분
  residentNo: string; // 주민등록번호
  accountNo: string; // 계좌번호
  etcInfo: string; // 기타 정보
  regDt: string; // 등록일시 (yyyyMMddHHmmss 형식)
  updDt: string | null; // 수정일시
  usrId: string; // 사용자 ID
  siteId: string; // 사이트 ID
  groupSeqNo: number; // 그룹 시퀀스 번호
  groupNm: string; // 그룹 이름
};

export const useSearchBuddyData = (groupSeqNo: string, keyword?: string) => {
  const fetchGroupBuddyList = async ({ pageSize, groupSeqNo, keyword, pageNumber }: any) => {
    try {
      const response = await instance.get('/groupBuddyList', {
        params: {
          pageSize,
          groupSeqNo,
          keyword,
          pageNumber,
        },
      });
      return response.data; // 응답 데이터 반환
    } catch (error) {
      console.error('Error fetching buddy list:', error);
      throw new Error('Failed to fetch buddy list'); // 에러 처리
    }
  };

  // Infinite query to fetch buddy list
  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage, refetch, isFetching } = useInfiniteQuery(
    ['groupBuddyList', keyword, groupSeqNo],
    ({ pageParam = 0 }) =>
      fetchGroupBuddyList({
        pageSize: 50,
        groupSeqNo,
        keyword,
        pageNumber: pageParam,
      }),
    {
      getNextPageParam: (lastPage, pages) => {
        return pages.length < lastPage.totalPages ? pages.length + 1 : undefined; // 페이지 인덱스 증가
      },
      enabled: keyword !== '',
    },
  );

  const buddyListData: ResponseData[] = data ? data.pages.flatMap((page) => page.content) : [];

  return {
    buddyListData,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
  };
};
